import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import CancelIcon from '@mui/icons-material/Cancel';
import { ResourceSchema, PlanSchema, MembershipSchema, BookingRecurrenceType, AccountSchema, AgreementMemberInfo, AgreementSubmissionSchema  } from "../../data/types";
import { useAddMembership, useCompleteSignIn, useGetCommunityMemberAgreement, useLoadMember, useUpdateMembership, useSubmitMemberAgreement, useGetMemberRequirementsStatus } from '../../hooks/authhooks';
import MembershipAgreementPreview, { MembershipAgreementPreviewHandle } from '../MembershipAgreementPreview';
import { useLoadMembershipPlans } from '../../hooks/apphooks';
import { getChangedAttributes, planRecurrenceMap, styleThousandCommas, countEffectivelyMetRequirements, buildInventoryItemsById, getInventorySelectionLabel, planHasDisplayFeatures } from '../../utils/helpers';
import { getAgreementMemberInfoValidationError, isAgreementMemberInfoComplete } from '../../utils/validationSchemas';
// import MembershipCard from '../components/MembershipCard';
import { ArrowBack, CheckBox, CheckBoxOutlineBlank, CheckCircle } from '@mui/icons-material';
import { MembershipAgreementSignedModal } from './AppModal';
import { ReactComponent as BookingPlanIcon } from '../../icons/BookingPlanIcon.svg';
// import { ReactComponent as KitchenIcon } from '../../icons/KitchenIcon.svg';
import { ReactComponent as InventoryIcon } from '../../icons/InventoryIcon.svg';
import { ReactComponent as NavResourcesIconDark } from '../../icons/NavResourcesIconDark.svg';
// import { cp } from 'fs';




// const phoneNumberStyling = (phoneNumber: string) => {
//   if (phoneNumber) {
//     var cleaned = ('' + phoneNumber).replace(/\D/g, '')
//     var match = cleaned.match(/^(0-1|)?(\d{3})(\d{3})(\d{4})$/)
//     if (match) {
//         var intlCode = (match[1] ? '+1 ' : '')
//         if (phoneNumber.length === 10){
//           phoneNumber = [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
//         } else if (phoneNumber.length > 3 && phoneNumber.length < 7){
//           phoneNumber = [intlCode, '(', match[2], ') ', match[3]].join('');
//         } else if (phoneNumber.length < 4){
//           phoneNumber = [intlCode, '(', match[2], ')'].join('');
//         }
//     }
//   }
//   return phoneNumber
// }


// const MEMBERSHIP_KEYS = Object.keys({} as MembershipSchema) as (keyof MembershipSchema)[];
// const filterMembershipFields = (data: any): Partial<MembershipSchema> => {
//   if (data === null || typeof data !== 'object') {
//     return [] as Partial<MembershipSchema>
//   }
//   const membershipKeys = Object.keys(data).filter(key => 
//     MEMBERSHIP_KEYS.includes(key as typeof MEMBERSHIP_KEYS[number])
//   );
//   return membershipKeys.reduce((acc, key) => ({
//     ...acc,
//     [key]: data[key]
//   }), {});
// };


type RequestMembershipFormProps = {
  resourceDetail: ResourceSchema
  currentMember: MembershipSchema | null;
  // plans: any[]
  formType: "request" | "manage" | null;
  handleClose: () => void;
  /** Pre-select this membership tier when opening from a MembershipTierCard */
  selectedPlan?: PlanSchema | null;
  // handleSubmitRequest: (resource: ResourceSchema, resourceType: ResourceType, booking: ResourceBookingSchema) => void
};

/** Copies plan identity/pricing fields onto a membership draft */
const membershipFieldsFromPlan = (plan?: PlanSchema | null): Partial<MembershipSchema> => {
  if (!plan?.plan_id) {
    return {}
  }
  return {
    plan_id: plan.plan_id,
    plan_name: plan.plan_name,
    plan_description: plan.plan_description,
    plan_recurrence: plan.plan_recurrence as BookingRecurrenceType,
    plan_rate: (plan.plan_rate || plan.plan_rate === 0) ? plan.plan_rate : 0,
  }
}
  
const RequestMembershipForm: React.FC<RequestMembershipFormProps> = (props) => {

  const navigate = useNavigate();
    var { resourceDetail, formType, handleClose, currentMember, selectedPlan } = props;
    const { user } = useCompleteSignIn();
    // const existingBusinesses: any[] = []
    const { allPlans } = useLoadMembershipPlans(resourceDetail?.community_id || "")
    const currentMembershipPlans: PlanSchema[] = allPlans ? allPlans : []
    // const [selectedBusiness, setSelectedBusinesses] = useState<string>("");

    const [submitted, setSubmitted] = useState<boolean>(false)

    const [newMembership, setNewMembership] = useState<MembershipSchema>({
      ...currentMember,
      first_name: currentMember?.first_name ? currentMember.first_name : user?.first_name ? user.first_name : "",
      last_name: currentMember?.last_name ? currentMember.last_name : user?.last_name ? user.last_name : "",
      email: currentMember?.email ? currentMember.email : user?.email ? user.email : "",
      phone: currentMember ? currentMember.phone : user?.phone ? user.phone : "",
      state: currentMember?.state ? currentMember.state : user?.state ? user.state : "",
      zipcode: currentMember?.zipcode ? currentMember.zipcode : user?.zipcode ? user.zipcode : "",
      ...membershipFieldsFromPlan(selectedPlan),
    });
    // const [membershipViewOption, setMembershipViewOption] = useState<"contact_info" | "membership_card">("contact_info");

    const communityId = resourceDetail?.community_id ? resourceDetail.community_id : ""
    const resourceId = resourceDetail?.id ? resourceDetail.id : ""
    const { addMembership } = useAddMembership(user?.uid ? user.uid : "", communityId)
    const { updateMembership } = useUpdateMembership(communityId)

    const handleSubmitNewMembership = async () => {  
      // console.log('newMembership', newMembership)
      if (
        newMembership?.first_name && newMembership?.last_name && 
        newMembership?.email && newMembership?.zipcode && 
        newMembership?.plan_id && communityId
      ){
        if (newMembership?.phone){
          newMembership.phone = (newMembership.phone.length === 10 && !newMembership.phone.includes('+1')) ? `+1${newMembership.phone}` : ""
        }
        newMembership.resource_id = resourceId
        addMembership(newMembership)
        const defaultMembership = {
          ...currentMember,
          first_name: currentMember?.first_name ? currentMember.first_name : user?.first_name ? user.first_name : "",
          last_name: currentMember?.last_name ? currentMember.last_name : user?.last_name ? user.last_name : "",
          email: currentMember?.email ? currentMember.email : user?.email ? user.email : "",
          phone: currentMember ? currentMember.phone : user?.phone ? user.phone : "",
          state: currentMember?.state ? currentMember.state : user?.state ? user.state : "",
          zipcode: currentMember?.zipcode ? currentMember.zipcode : user?.zipcode ? user.zipcode : ""
        }
        setNewMembership(defaultMembership)
        navigate(`/profile/memberships?id=${currentMember?.community_id || communityId}`)
        setSubmitted(true)
        // handleClose()
      }
    }  


    const handleSubmitMembershipUpdate = async () => {    
      if (
        newMembership?.first_name && newMembership?.last_name && 
        newMembership?.email && newMembership?.zipcode && 
        newMembership?.plan_id && communityId
      ){
        if (newMembership?.phone){
          newMembership.phone = (newMembership.phone.length === 10 && !newMembership.phone.includes('+1')) ? `+1${newMembership.phone}` : ""
        }
        newMembership.resource_id = resourceId
        const changedAttributes = getChangedAttributes(currentMember || {} as MembershipSchema, newMembership)
        // console.log("changedAttributes", changedAttributes)
        updateMembership(changedAttributes)
        const defaultMembership = {
          ...currentMember,
          first_name: currentMember?.first_name ? currentMember.first_name : user?.first_name ? user.first_name : "",
          last_name: currentMember?.last_name ? currentMember.last_name : user?.last_name ? user.last_name : "",
          email: currentMember?.email ? currentMember.email : user?.email ? user.email : "",
          phone: currentMember ? currentMember.phone : user?.phone ? user.phone : "",
          state: currentMember?.state ? currentMember.state : user?.state ? user.state : "",
          zipcode: currentMember?.zipcode ? currentMember.zipcode : user?.zipcode ? user.zipcode : ""
        }
        setNewMembership(defaultMembership)
        navigate(`/profile/memberships?id=${currentMember?.community_id || communityId}`)
        setSubmitted(true)
        // handleClose()
      }
    } 

    useEffect(() => {
      const defaultMembership = {
        ...currentMember,
        first_name: currentMember?.first_name ? currentMember.first_name : user?.first_name ? user.first_name : "",
        last_name: currentMember?.last_name ? currentMember.last_name : user?.last_name ? user.last_name : "",
        email: currentMember?.email ? currentMember.email : user?.email ? user.email : "",
        phone: currentMember ? currentMember.phone : user?.phone ? user.phone : "",
        state: currentMember?.state ? currentMember.state : user?.state ? user.state : "",
        zipcode: currentMember?.zipcode ? currentMember.zipcode : user?.zipcode ? user.zipcode : "",
        ...membershipFieldsFromPlan(selectedPlan),
      }
      setNewMembership(defaultMembership)
    }, [currentMember, user, selectedPlan])

    // const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //   const { name, value } = event.target;
    //   if (name && value) {
    //     setApplication((prev => ({
    //       ...prev,
    //       [name]: value
    //     })));
    //   }
    // };

    // const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //   const { name, value } = event.target;
    //   if (name && (value || value === "")) {
    //     if (name === 'phone'){
    //       const phone = ('' + value).replace(/\D/g, '')
    //       if ((!isNaN(parseInt(phone)) && phone.length <= 10) || phone === ""){
    //         // setMemberPhone(value)  
    //         setNewMembership((prev) => ({
    //           ...prev,
    //           [name]: value
    //         }))
    //       } 
    //     } else {
    //       if (name === 'first_name'){
    //         // setFirstName(value)
    //       } else if (name === 'last_name'){
    //         // setLastName(value)
    //       } else if (name === 'email'){
    //         // setMemberEmail(value)
    //       } else if (name === 'zipcode'){
    //         // setUserZipCode(value)
    //       }
          
    //       setNewMembership((prev) => ({
    //         ...prev,
    //         [name]: value
    //       }))
    //     }
    //   }
    // };



    const handleSelectInput = (e: React.ChangeEvent<HTMLSelectElement>) => {
      // e.preventDefault()
      const {name, value} = e.target
      if (name && value){
        if (name === 'state'){
          // setUserUSState(value)
          setNewMembership((prev) => ({
            ...prev,
            [name]: value
          }))
        } else if (name === 'plan'){
          let plan = currentMembershipPlans.find(plan => (plan?.plan_id && (plan.plan_id === value))) as PlanSchema
          var { plan_id,  plan_name, plan_description, plan_recurrence, plan_rate } = plan
          // setSelectedPlan(plan)
          setNewMembership((prev) => ({
            ...prev,
            plan_id,  
            plan_name, 
            plan_description, 
            plan_recurrence: plan_recurrence as BookingRecurrenceType, 
            plan_rate: (plan_rate || plan_rate === 0) ? plan_rate : 0
          }))
        }
         // else if (name === 'businessId'){
        //   setSelectedBusinesses(value)
        // } 
      }
    }


    const { reloadCurrentMember } = useLoadMember(communityId)

    const handleViewCurrentStatus = () => {
      reloadCurrentMember()
      setSubmitted(false)
    }


    if (submitted){
      return (
        <SubmittedLogin
          resourceName={resourceDetail?.name as string} 
          handleViewCurrentStatus={handleViewCurrentStatus}
          handleClose={handleClose}
        />
      )
    } else {
      return (
        <MembershipFormTasks 
          // resourceName={resourceDetail?.name as string} 
          handleClose={handleClose}
          resourceDetail={resourceDetail}
          currentMember={currentMember}
          newMembership={newMembership}
          setNewMembership={setNewMembership}
          currentMembershipPlans={currentMembershipPlans}
          selectedPlan={selectedPlan}
          user={user}
          formType={formType}
          // handleInputChange={handleInputChange}
          handleSelectInput={handleSelectInput}
          handleSubmitMembershipUpdate={handleSubmitMembershipUpdate}
          handleSubmitNewMembership={handleSubmitNewMembership}

        />
      )
    }
  };

  export default RequestMembershipForm


  type MembershipFormTasksProps = {
    // resourceName: string
    handleClose: () => void
    resourceDetail: ResourceSchema
    currentMember: MembershipSchema | null
    newMembership: MembershipSchema
    setNewMembership: React.Dispatch<React.SetStateAction<MembershipSchema>>
    currentMembershipPlans: PlanSchema[]
    selectedPlan?: PlanSchema | null
    user: AccountSchema | null | undefined
    formType: "request" | "manage" | null
    // handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    handleSelectInput: (e: React.ChangeEvent<HTMLSelectElement>) => void
    handleSubmitMembershipUpdate: () => void
    handleSubmitNewMembership: () => void
  }

  const MembershipFormTasks: React.FC<MembershipFormTasksProps> = ({
    handleClose, resourceDetail, currentMember,
    newMembership, setNewMembership, user, formType, handleSelectInput, 
    handleSubmitNewMembership, handleSubmitMembershipUpdate, currentMembershipPlans,
    selectedPlan,
  
  }) => {

    const navigate = useNavigate()
    const location = useLocation()
    const isOnProfileRoute = location.pathname === '/profile' || location.pathname === '/profile/memberships'
    const handleUpdateProfileClick = () => {
      if (isOnProfileRoute) {
        handleClose()
      }
      navigate('/profile')
    }
    const [isSelectingPlan, setIsSelectingPlan] = useState<boolean>(false)
    const [isShowingAgreement, setIsShowingAgreement] = useState<boolean>(false)
    const [isShowingSignedAgreementSuccessModal, setIsShowingSignedAgreementSuccessModal] = useState<boolean>(false)

    const loggedinUid = user?.uid ? user?.uid : "";
    const { memberRequirementStatuses } = useGetMemberRequirementsStatus(loggedinUid);
    const requirementsStatus = memberRequirementStatuses[currentMember?.community_id as string] || [];
    const totalRequirementsCount = requirementsStatus.filter(
        (item) => item.is_required === true
      ).length;
    const metRequirementsCount = countEffectivelyMetRequirements(requirementsStatus);

    // const isDisableSubmitButton = (!newMembership.plan_id) && !(newMembership.first_name && newMembership.last_name && newMembership.email && newMembership.zipcode)
    return (
      <>
      <div className="flex flex-col justify-evenly items-center h-full">
        <div className="h-auto flex flex-col justify-evenly items-center w-full bg-[#F8F8F8]/70 p-4">
          <span onClick={handleClose} className="ml-auto w-full flex cursor-pointer">
              <CancelIcon className="text-[#A1A1A1] hover:text-[#777] h-[18px] w-[18px] ml-auto" />
          </span>

          {/* <div className='h-[4px] border-0 bg-primaryDark-400 w-11/12 my-4' /> */}
          <img src={resourceDetail?.logo ? resourceDetail.logo : "/logo192.png"} alt="homecook-logo" className="h-[60px] self-center mb-2 m-1 rounded-lg"/>
          
          <p className='text-[#808080] text-[16px] font-raleway text-center w-11/12'>
            <span className='font-semibold'>{resourceDetail.name}</span>
          </p>

          {
            (isShowingAgreement) ? (
              <>
                <button onClick={()=> setIsShowingAgreement(false)} className={`flex flex-row mt-2 align-middle border-0 justify-center items-center text-gray-500 w-auto h-[33px] font-semibold  text-[14px] font-raleway text-center mr-auto rounded-xl px-4 py-2`}>
                  <ArrowBack className="mr-2" /> Back to Checklist
                </button>
                <p className="text-left text-[18px] mt-4 font-raleway font-semibold text-[#4D4D4D] w-11/12">Sign Membership Agreement</p>
                <p className="text-left text-[14px] font-open-sans font-normal text-[#808080] w-11/12">Review the agreement, complete your details, sign, and submit to finish your membership application.</p>
              </>
            ) : (
              <>
                <p className="text-left text-[18px] mt-4 font-raleway font-semibold text-[#4D4D4D] w-11/12">{((formType === "manage") ? "Manage Membership" : "Request Membership")}</p>
                <p className="text-left text-[14px] font-open-sans font-normal text-[#808080] w-11/12">{((formType === "manage") ? "Update your membership information." : "Fill out the details below to began your membership application.")}</p>
              </>
            )
          }  
        </div>
        {(!isShowingAgreement) ? (
        <>
        <div className='flex flex-col w-11/12 my-2'>
          <div className={`flex flex-row mt-2 items-center ${((user && user.first_name && user.last_name && user.email && user.state && user.zipcode && newMembership.plan_id) ? "text-[#0F973D] bg-[#E9FBE9]" : "text-[#D42620] bg-[#FBE9E9]")} w-auto h-[33px] font-semibold  text-[14px] font-raleway text-center mr-auto rounded-xl px-4 py-2`}>
            Complete First
          </div>
          <div className='flex flex-row border-[1px] border-[#E9E9E9] p-3 rounded-lg w-full my-2'>
            {(user && user.first_name && user.last_name && user.email && user.state && user.zipcode) ? (
                <CheckBox className="my-auto text-primaryDark-300" />
              ) : (
                <CheckBoxOutlineBlank className="my-auto text-[#CFCFCF]" />
              )}
            <div className='flex flex-col my-4 ml-4 w-3/5'>
              <p className='text-[16px] font-raleway text-black text-left font-medium w-full'>Complete Profile</p>
              <p className='text-[14px] font-open-sans text-[#4D4D4D] text-left font-normal w-full'>
                Complete your profile by adding your first name, last name, email, state, and zipcode.
              </p>
            </div>
            <button 
              onClick={handleUpdateProfileClick}
              disabled={(user && user.first_name && user.last_name && user.email && user.state && user.zipcode) ? true : false} 
              className={` ${((user && user.first_name && user.last_name && user.email && user.state && user.zipcode) ? "bg-gray-200 cursor-not-allowed text-gray-500" : "hover:bg-primaryDark-300 bg-primaryDark-200")} border-0 font-semibold font-raleway my-auto h-auto ml-auto text-[14px] text-white px-3 py-2 rounded-lg`}
            >
              Update Profile
            </button>
          </div>

         {(!isSelectingPlan) ? (
          <div className='flex flex-col border-[1px] border-[#E9E9E9] p-3 rounded-lg w-full my-2'>
            <div className='flex flex-row'>
              {(newMembership.plan_id) ? (
                  <CheckBox className="my-auto text-primaryDark-300" />
                ) : (
                  <CheckBoxOutlineBlank className="my-auto text-[#CFCFCF]" />
                )}
              <div className='flex flex-col my-4 ml-4 w-3/5'>
                <p className='text-[16px] font-raleway text-black text-left font-medium w-full'>Select Membership Tier</p>
                <p className='text-[14px] font-open-sans text-[#4D4D4D] text-left font-normal w-full'>
                  Select the membership tier that you would like to join.
                </p>
              </div>
              <button 
                className='bg-primaryDark-200 hover:bg-primaryDark-300 border-0 font-semibold font-raleway my-auto cursor-pointer h-auto ml-auto text-[14px] text-white px-3 py-2 rounded-lg'
                onClick={()=> setIsSelectingPlan(true)}
                // disabled={newMembership.plan_id ? true : false}
              >{newMembership.plan_id ? 'Update Membership Tier' : 'Select Membership Tier'}</button>
            </div>
            <MembershipTierDetails
              plan={
                (currentMembershipPlans.find(plan => plan.plan_id === newMembership.plan_id)
                  || (selectedPlan?.plan_id === newMembership.plan_id ? selectedPlan : undefined)
                  || (newMembership.plan_id ? {
                      plan_id: newMembership.plan_id,
                      plan_name: newMembership.plan_name,
                      plan_description: newMembership.plan_description,
                      plan_recurrence: newMembership.plan_recurrence,
                      plan_rate: newMembership.plan_rate,
                    } as PlanSchema : undefined)) as PlanSchema
              }
            />
          </div>
          ) : (
            <SelectMembershipTier newMembership={newMembership} currentMembershipPlans={currentMembershipPlans} resourceDetail={resourceDetail} handleSelectInput={handleSelectInput} setIsSelectingPlan={setIsSelectingPlan} />
          )}


          <div className='flex flex-row mt-2 items-center text-[#4D4D4D] w-auto h-[33px] font-semibold bg-[#F8F8F8] text-[14px] font-raleway text-center mr-auto rounded-xl px-4 py-2'>
            Later
          </div>


          <div className='flex flex-row border-[1px] border-[#E9E9E9] p-3 rounded-lg w-full my-2'>
            {(newMembership.member_agreement?.submitted && newMembership.member_agreement?.file_key && newMembership.member_agreement?.file_url) ? (
                <CheckBox className="my-auto text-primaryDark-300" />
              ) : (
                <CheckBoxOutlineBlank className="my-auto text-[#CFCFCF]" />
              )}
            <div className='flex flex-col my-4 ml-4 w-3/5'>
              <p className='text-[16px] font-raleway text-black text-left font-medium w-full'>Membership Agreement</p>
              <p className='text-[14px] font-open-sans text-[#4D4D4D] text-left font-normal w-full'>
                This agreement outlines the terms of your membership, including your responsibilities and access rights.
              </p>
            </div>    

            {
              (newMembership.member_agreement?.submitted && newMembership.member_agreement?.file_key && newMembership.member_agreement?.file_url) ? (
                <button 
                  className={`${((formType === "manage") ? "hover:bg-primaryDark-300 bg-primaryDark-200" : "bg-gray-200 cursor-not-allowed text-gray-500")} border-0 font-semibold font-raleway my-auto h-auto ml-auto text-[14px] text-white px-3 py-2 rounded-lg`}
                  onClick={() => formType === "manage" && setIsShowingSignedAgreementSuccessModal(true)}
                >
                  View Signed Agreement
                </button>
              ) : (
                <button 
                  // disabled={(formType !== "manage") ? false : true}
                  className={`${((formType === "manage") ? "hover:bg-primaryDark-300 bg-primaryDark-200" : "bg-gray-200 cursor-not-allowed text-gray-500")} border-0 font-semibold font-raleway my-auto h-auto ml-auto text-[14px] text-white px-3 py-2 rounded-lg`}
                  onClick={()=> setIsShowingAgreement(true)}
                >
                  Sign Agreement
                </button>
              )
            }
          </div>

          <div className='flex flex-row border-[1px] border-[#E9E9E9] p-3 rounded-lg w-full my-2'>
            {(metRequirementsCount / totalRequirementsCount >= 1) ? (
                <CheckBox className="my-auto text-primaryDark-300" />
              ) : (
                <CheckBoxOutlineBlank className="my-auto text-[#CFCFCF]" />
              )}
            <div className='flex flex-col my-4 ml-4 w-3/5'>
              <p className='text-[16px] font-raleway text-black text-left font-medium w-full'>Upload Required Documents</p>
              <p className='text-[14px] font-open-sans text-[#4D4D4D] text-left font-normal w-full'>
                Upload the required documents to complete your membership application.
              </p>
            </div>
            <button 
              disabled={(formType === "manage") ? false : true}
              onClick={() => {
                if (formType !== "manage") return;
                if (location.pathname === '/profile/memberships') {
                  handleClose();
                } else {
                  navigate(`/profile/memberships?id=${currentMember?.community_id || resourceDetail?.community_id}`);
                }
              }}
              className={`${((formType === "manage") ? "hover:bg-primaryDark-300 bg-primaryDark-200" : "bg-gray-200 cursor-not-allowed text-gray-500")} border-0 font-semibold font-raleway my-auto h-auto ml-auto text-[14px] text-white px-3 py-2 rounded-lg`}
            >
              Upload Documents
            </button>
          </div>
        </div>

        <div className='flex flex-row my-2 w-11/12'>
          <button
              className="py-2 w-[217px] mr-auto font-semibold text-[16px] font-raleway text-primaryDark-0 border-[#E9E9E9] border-[1px]"
              data-testid="cancel-button"
              onClick={handleClose}
            > 
                  Cancel  
          </button>
          <button
              className={`py-2 w-[217px] ml-auto font-semibold text-[16px] font-raleway border-0 ${((newMembership.plan_id && newMembership.plan_id !== currentMember?.plan_id) && (newMembership.first_name && newMembership.last_name && newMembership.email && newMembership.zipcode)) ? "bg-primaryDark-200 hover:bg-primaryDark-300 text-white" : "bg-gray-200 cursor-not-allowed text-gray-500"}`}
              onClick={ () => (newMembership.plan_id && newMembership.plan_id !== currentMember?.plan_id && formType === "manage") ? handleSubmitMembershipUpdate() : handleSubmitNewMembership()}
              disabled={(!newMembership.plan_id && newMembership.plan_id !== currentMember?.plan_id) && !(newMembership.first_name && newMembership.last_name && newMembership.email && newMembership.zipcode)}
              data-testid="submit-button"> 
                  {formType === "manage" ? "Save Changes" : "Submit Request"}  
          </button>
        </div>
        </>
        ) : (
          <MembershipAgreement
            authUser={user as AccountSchema}
            communityId={resourceDetail.community_id || ""}
            onAgreementSubmittedSuccess={(response) => {
              if (response?.member_agreement) {
                setNewMembership((prev) => ({ ...prev, member_agreement: response.member_agreement }));
              }
              setIsShowingAgreement(false);
              setIsShowingSignedAgreementSuccessModal(true);
            }}
          />
        )}
      </div>
      {isShowingSignedAgreementSuccessModal && (
          <MembershipAgreementSignedModal 
            isOpen={isShowingSignedAgreementSuccessModal} 
            newMembership={newMembership} 
            setIsShowingSignedAgreementSuccessModal={setIsShowingSignedAgreementSuccessModal} 
            setIsShowingAgreement={setIsShowingAgreement} 
            closeAppModal={handleClose} 
            // formType={formType} 
          />
      )}
      </>
    );
  };


  type MembershipTierDetailsProps = {
    // newMembership: MembershipSchema
    plan: PlanSchema
  }

  const MembershipTierDetails: React.FC<MembershipTierDetailsProps> = ({ plan }) => {
    if (!plan || !plan.plan_name) {
      return null;
    }

    // const formatMaxHours = (maxHours?: number) => {
    //   return maxHours ? `${maxHours} Max Hours` : '';
    // };

    return (
      <div className="bg-[#F8F8F8] rounded-lg p-3 ">
        <div className="flex items-start justify-between">
          {/* Left side - Tier name and description */}
          <div className="flex-1">
            <h3 className="text-[16px] font-raleway font-semibold text-gray-900 mb-2">
              {plan.plan_name}
            </h3>
            <p className="text-[#4D4D4D] text-[14px] font-open-sans font-normal">
              {(!plan.plan_description || plan.plan_description?.length < 50) ? plan.plan_description : `${plan.plan_description?.slice(0, 50)}...`}
              {/* <span className="text-teal-600 cursor-pointer hover:text-teal-700 underline ml-1">
                See all
              </span> */}
            </p>
          </div>

          {/* Right side - Price and max hours */}
          <div className="text-right ml-4">
            <div className="text-[16px] font-raleway font-semibold text-gray-900 mb-1">
              ${plan.plan_rate && styleThousandCommas(plan.plan_rate)} / {planRecurrenceMap[plan.plan_recurrence as keyof typeof planRecurrenceMap]}
            </div>
          </div>
        </div>
      </div>
    )
  }



  type SubmittedLoginProps = {
    resourceName: string
    handleClose: () => void
    handleViewCurrentStatus: () => void
  }

  const SubmittedLogin: React.FC<SubmittedLoginProps> = ({resourceName, handleClose, handleViewCurrentStatus}) => {  
    return (
      <div className="flex flex-col justify-evenly items-center h-full my-2">
        <span onClick={handleClose} className="ml-auto w-full flex cursor-pointer">
            <CancelIcon className="text-[#A1A1A1] hover:text-[#777] h-[18px] w-[18px] ml-auto" />
        </span>
      <div className="flex items-center justify-center rounded-full p-3 border-[#E6E6E6] border-[1px] w-[64px] h-[64px] mx-auto">
          <CheckCircle style={{fontSize: 32}} className="m-auto" />
        </div>
        
        <h1 className="text-md text-primaryDark-200 font-bold my-2 font-raleway text-[24px] text-center w-11/12">Membership Request Successful!</h1>
        <p className="text-[16px] text-center my-2 text-[#333333] font-open-sans w-11/12">
          Thank you for choosing to use <b>{resourceName}</b>! Your request has been successfully received. You will receive an email with the details and next steps shortly.
        </p>
        <button 
          onClick={handleViewCurrentStatus}
          className={`w-11/12 h-[54px] bg-[#013847] hover:bg-[#E6E6E6] text-white font-bold border-0 text-[18px] my-4`}
        >
          
          Check Membership Status
        </button>
      </div>
    )
  }


  type SelectMembershipTierProps = {
    newMembership: MembershipSchema
    currentMembershipPlans: PlanSchema[]
    resourceDetail?: ResourceSchema
    handleSelectInput: (e: React.ChangeEvent<HTMLSelectElement>) => void
    setIsSelectingPlan: React.Dispatch<React.SetStateAction<boolean>>
  }

  /** Renders selectable membership tiers, including dual-plan booking coverage and bundled inventory */
  export const SelectMembershipTier: React.FC<SelectMembershipTierProps> = ({ newMembership, currentMembershipPlans, resourceDetail, handleSelectInput, setIsSelectingPlan }) => {
    const inventoryItemsById = useMemo(
      () => buildInventoryItemsById(resourceDetail),
      [resourceDetail]
    );

    const handlePlanSelect = (planId: string) => {
      const event = {
        target: {
          name: 'plan',
          value: planId
        }
      } as React.ChangeEvent<HTMLSelectElement>;
      handleSelectInput(event);
    };

    // const formatMaxHours = (maxHours?: number) => {
    //   return maxHours ? `${maxHours} Max Hours` : '';
    // };

    return (
      <div className="flex flex-col w-full my-4">
        <label className='text-black font-medium text-[16px] font-raleway text-left mb-4'>
          Select Membership Tier
        </label>
        
        <div className="space-y-3">
          {currentMembershipPlans.map((plan, index) => (
            <div 
              key={plan.plan_id || index}
              className={`border border-gray-200 rounded-lg p-4 cursor-pointer transition-all duration-200 ${
                newMembership?.plan_id === plan.plan_id 
                  ? 'border-primaryDark-400 bg-primaryDark-400/10' 
                  : 'hover:border-gray-300'
              }`}
              onClick={() => handlePlanSelect(plan.plan_id || '')}
            >
              <div className="flex items-start justify-between">
                <div className="flex items-start space-x-3 flex-1">
                  {/* Radio Button */}
                  <div className="flex items-center mt-1">
                    <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
                      newMembership?.plan_id === plan.plan_id 
                        ? 'border-primaryDark-400 bg-primaryDark-400' 
                        : 'border-gray-300'
                    }`}>
                      {newMembership?.plan_id === plan.plan_id && (
                        <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                      )}
                    </div>
                  </div>

                  {/* Plan Details */}
                  <div className="flex-1 min-w-0">
                    <div className="flex flex-wrap items-center gap-2 mb-1">
                      <h3 className="text-[18px] font-semibold font-raleway text-black">
                        {plan.plan_name}
                      </h3>
                      {plan.plan_type === 'dual' && (
                        <span
                          className="inline-flex items-center gap-1 text-[12px] font-raleway font-medium text-primaryDark-300 bg-primaryDark-400/10 rounded-md px-2 py-1"
                          data-testid="dual-plan-badge"
                        >
                          <BookingPlanIcon className="w-3.5 h-3.5 shrink-0" aria-hidden />
                          Covers Booking
                        </span>
                      )}
                    </div>
                    <p className="text-[#4D4D4D] text-[16px] font-open-sans mb-3">
                      {(!plan.plan_description || plan.plan_description?.length < 50) ? plan.plan_description : `${plan.plan_description?.slice(0, 50)}...`}
                    </p>
                    
                    {/* Features + associated resources / inventory */}
                    {planHasDisplayFeatures(plan.features, plan.associated_resources) && (
                    <div className="mt-3">
                      <p className="text-xs font-raleway text-gray-500 mb-2">Plan Features</p>
                      <div className="space-y-1.5">
                        {plan.features?.map((feature, featureIndex) => (
                          <div key={`feature-${featureIndex}`} className="flex items-center space-x-2">
                            <div className="w-4 h-4 rounded-full bg-primaryDark-400/10 flex items-center justify-center shrink-0">
                              <svg className="w-2.5 h-2.5 text-primaryDark-300" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                              </svg>
                            </div>
                            <span className="text-[14px] text-gray-700 font-open-sans font-normal">{feature}</span>
                          </div>
                        ))}
                        {plan.associated_resources?.map((association, associationIndex) => (
                          <div key={`assoc-${association.resource_id || associationIndex}`} className="space-y-1">
                            {(association.resource_name || association.resource_id) && (
                              <div className="flex items-center space-x-2">
                                <div className="w-4 h-4 rounded-full bg-primaryDark-400/10 flex items-center justify-center shrink-0">
                                  <NavResourcesIconDark className="w-2.5 h-2.5 text-primaryDark-300" aria-hidden />
                                </div>
                                <span className="text-[14px] text-gray-700 font-open-sans font-normal truncate">
                                  {association.resource_name || 'Linked resource'}
                                  {/* {resourceDetail?.resource_type ? `(${capitalizeString(resourceDetail?.resource_type)})` : ''} */}
                                </span>
                              </div>
                            )}
                            {association.inventory?.map((selection, inventoryIndex) => (
                              <div
                                key={`inventory-${associationIndex}-${selection.inventory_id}-${inventoryIndex}`}
                                className={`flex items-center space-x-2 ${(association.resource_name || association.resource_id) ? 'ml-5' : ''}`}
                              >
                                <div className="w-4 h-4 rounded-full bg-primaryDark-400/10 flex items-center justify-center shrink-0">
                                  <InventoryIcon className="w-2.5 h-2.5 text-primaryDark-300" aria-hidden />
                                </div>
                                <span className="text-[14px] text-gray-700 font-open-sans font-normal truncate">
                                  {getInventorySelectionLabel(selection, inventoryItemsById)}
                                </span>
                                {selection.max_qty > 0 && (
                                  <span className="text-[12px] text-gray-500 font-open-sans shrink-0">
                                    · max {selection.max_qty}
                                  </span>
                                )}
                              </div>
                            ))}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  </div>

                  {/* Price */}
                  <div className="text-right ml-4">
                    <div className="text-[18px] font-raleway font-semibold text-black">
                      ${plan.plan_rate && styleThousandCommas(plan.plan_rate)} / {planRecurrenceMap[plan.plan_recurrence as keyof typeof planRecurrenceMap]}
                    </div>
                    {/* <div className="text-[16px] font-open-sans font-light text-[#4D4D4D]">
                      {formatMaxHours(plan.plan_max_hours)}
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Confirm Button */}
        <button 
          onClick={() => setIsSelectingPlan(false)}
          className={`mt-6 w-full py-3 px-4 rounded-lg font-semibold text-white transition-colors border-0 duration-200 ${
            newMembership?.plan_id 
              ? 'bg-primaryDark-300 hover:bg-primaryDark-500' 
              : 'bg-gray-300 cursor-not-allowed'
          }`}
          disabled={!newMembership?.plan_id}
        >
          Confirm Membership Tier
        </button>
      </div> 
    )
  }


  const defaultMemberInfo = (user: AccountSchema | null | undefined): AgreementMemberInfo => ({
    fullName: [user?.first_name, user?.last_name].filter(Boolean).join(' ').trim() || '',
    companyName: '',
    date: new Date().toISOString().slice(0, 10),
    titlePosition: '',
    address: user?.address ?? '',
    city: user?.city ?? '',
    state: user?.state ?? '',
    zipcode: user?.zipcode ?? '',
    phone: user?.phone ?? '',
    ownerDriversLicense: '',
    ownerSSN: '',
    memberFEIN: '',
    memberInsurance: '',
    foodSafetyCertDate: '',
  });

  type MembershipAgreementProps = {
    communityId: string;
    authUser: AccountSchema;
    onAgreementSubmittedSuccess?: (response: MembershipSchema) => void;
  }

  const MembershipAgreement: React.FC<MembershipAgreementProps> = ({ communityId, authUser, onAgreementSubmittedSuccess }) => {
    const { agreement: memberAgreement, agreementLoading } = useGetCommunityMemberAgreement(communityId);
    const [memberInfo, setMemberInfo] = useState<AgreementMemberInfo>(() => defaultMemberInfo(authUser));
    const [previewHtml, setPreviewHtml] = useState<string | null>(null);
    const [submittingAgreement, setSubmittingAgreement] = useState(false);
    const [submitAgreementError, setSubmitAgreementError] = useState<string | null>(null);
    const [interactionMode, setInteractionMode] = useState<'edit' | 'submit-review'>('edit');
    const previewRef = useRef<MembershipAgreementPreviewHandle>(null);
    const { submitAgreement } = useSubmitMemberAgreement(authUser?.uid ?? '', communityId as string)
    const canSubmitAgreement = useMemo(() => isAgreementMemberInfoComplete(memberInfo), [memberInfo]);

    const showAgreementValidationError = (message: string) => {
      setSubmitAgreementError(message);
      previewRef.current?.highlightMissingFields();
      previewRef.current?.scrollToFirstInvalidField();
    };

    const handlePreviewBeforeSubmit = async () => {
      setSubmitAgreementError(null);
      const validationError = getAgreementMemberInfoValidationError(memberInfo);
      if (validationError) {
        showAgreementValidationError(validationError);
        return;
      }
      const fieldsValid = await previewRef.current?.validateMemberInfo();
      if (fieldsValid === false) return;
      setInteractionMode('submit-review');
    };

    const handleBackToEdit = () => {
      setInteractionMode('edit');
      setSubmitAgreementError(null);
    };

    const handleSubmitAgreement = async () => {
      setSubmitAgreementError(null);
      const validationError = getAgreementMemberInfoValidationError(memberInfo);
      if (validationError) {
        showAgreementValidationError(validationError);
        return;
      }
      const fieldsValid = await previewRef.current?.validateMemberInfo();
      if (fieldsValid === false) return;
      setSubmittingAgreement(true);
      try {
        const agreementSubmission: AgreementSubmissionSchema = {
          ...memberInfo,
          content: previewHtml ?? undefined,
          community_id: memberAgreement?.community_id,
          agreement_source_id: memberAgreement?.id,
          file_url: memberAgreement?.url,
          file_key: memberAgreement?.file_key,
          security_deposit: memberAgreement?.security_deposit,
          username: authUser?.email,
        };
        const response = await submitAgreement(agreementSubmission);
        const valid = response && response.member_agreement && response.member_agreement.submitted && response.member_agreement.file_url;
        if (valid) {
          if (onAgreementSubmittedSuccess) {
            onAgreementSubmittedSuccess(response);
          }
        } else {
          setSubmitAgreementError('Agreement submission failed. Please try again.');
        }
      } catch {
        setSubmitAgreementError('Agreement submission failed. Please try again.');
      } finally {
        setSubmittingAgreement(false);
      }
    }

    useEffect(() => {
      setMemberInfo(prev => ({
        ...prev,
        fullName: [authUser?.first_name, authUser?.last_name].filter(Boolean).join(' ').trim() || prev.fullName,
        zipcode: authUser?.zipcode ?? prev.zipcode,
        address: authUser?.address ?? prev.address,
        city: authUser?.city ?? prev.city,
        state: authUser?.state ?? prev.state,
        phone: authUser?.phone ?? prev.phone,
      }));
    }, [authUser?.first_name, authUser?.last_name, authUser?.zipcode, authUser?.address, authUser?.city, authUser?.state, authUser?.phone]);

    return (
      <div className='flex flex-col w-11/12 mx-auto my-2'>
        <MembershipAgreementPreview
          ref={previewRef}
          authUser={authUser}
          memberAgreement={memberAgreement ?? undefined}
          memberInfo={memberInfo}
          setMemberInfo={setMemberInfo}
          agreementLoading={agreementLoading}
          variant="desktop"
          interactionMode={interactionMode}
          onPreviewHtmlChange={setPreviewHtml}
        />
        <div className='flex flex-col w-full mt-4'>
          {interactionMode === 'submit-review' && (
            <p className="mb-3 text-[14px] font-open-sans text-[#4D4D4D]">
              Review your completed agreement above, submit when ready.
            </p>
          )}
          {submitAgreementError && (
            <div data-testid="submit-agreement-error" className="mb-3 px-4 py-3 rounded font-raleway text-[14px] bg-red-50 text-red-700 border border-red-200">
              {submitAgreementError}
            </div>
          )}
          {submittingAgreement && (
            <div data-testid="submit-agreement-loading" className="mb-3 flex items-center gap-2 font-raleway text-[14px] text-[#4D4D4D]">
              <span className="inline-block w-4 h-4 border-2 border-primaryDark-200 border-t-transparent rounded-full animate-spin" aria-hidden />
              Submitting agreement…
            </div>
          )}
          <div className='flex flex-row w-full justify-end gap-2'>
            {interactionMode === 'submit-review' ? (
              <button
                type="button"
                onClick={handleBackToEdit}
                disabled={submittingAgreement}
                className='px-4 py-3 border-[1px] border-[#E9E9E9] font-semibold text-[16px] font-raleway bg-white text-gray-600 hover:bg-gray-50 rounded-lg transition-colors disabled:opacity-60'
              >
                Back to edit
              </button>
            ) : (
              <button
                type="button"
                onClick={handlePreviewBeforeSubmit}
                disabled={submittingAgreement}
                className='px-4 py-3 border-[1px] border-[#E9E9E9] font-semibold text-[16px] font-raleway bg-white text-gray-600 hover:bg-gray-50 rounded-lg transition-colors disabled:opacity-60'
              >
                Preview
              </button>
            )}
            <button
              type="button"
              onClick={interactionMode === 'submit-review' ? handleSubmitAgreement : handlePreviewBeforeSubmit}
              disabled={submittingAgreement || !canSubmitAgreement}
              className='px-6 py-3 border-0 font-semibold text-[16px] font-raleway bg-primaryDark-200 text-white hover:bg-primaryDark-300 disabled:opacity-60 disabled:cursor-not-allowed'
            >
              Submit Agreement
            </button>
          </div>
        </div>
      </div>
    )
  }


